/**
 * ════════════════════════════════════════════════════════════════════
 * KEEP MEMORIZ — assets/km-avis-blog-translate.js
 * 1) Traduit les 127 avis (y compris ceux chargés dynamiquement)
 * 2) Corrige les URLs des articles blog pour /en/
 * ════════════════════════════════════════════════════════════════════
 */
(function () {
  var lang = (window.KM_LANG || 'fr').toLowerCase();
  if (lang === 'fr') return;

  var AVIS_EN = [
    "Gifted to the newlyweds, they were thrilled.",
    "No more headaches.",
    "We made the right choice.",
    "You made our wedding even more beautiful.",
    "The guests are still talking about it.",
    "We'll use it again for the next event.",
    "We tested it beforehand, super easy.",
    "430 photos collected!",
    "Not a single glitch.",
    "Received within a few hours.",
    "The guests' videos are amazing.",
    "We're using it again for the baptism.",
    "Our favorite gallery.",
    "Even my mom managed to scan it.",
    "We made a photo book from it.",
    "We'd do it again without hesitation.",
    "Perfect.",
    "Nothing to complain about.",
    "The next morning we spent brunch looking at the photos.",
    "The QR code was a hit.",
    "Videos that made us cry.",
    "Even 70-year-olds scanned it.",
    "Not a single bug.",
    "The guests loved it.",
    "I recommend without hesitation.",
    "I recommend.",
    "420 photos and 80 videos collected.",
    "The gallery is wonderful.",
    "Best wedding purchase.",
    "Natural photos, we love them.",
    "Better than the WhatsApp group.",
    "We still look at the gallery.",
    "Varied photos and videos.",
    "Nice surprise for the guests.",
    "Original and practical.",
    "The guests played along.",
    "380 photos in one evening.",
    "From order to result, top notch.",
    "Everything worked.",
    "QR code received fast, it works by itself.",
    "Customer service is excellent.",
    "The QR code made all the difference.",
    "Way better than a photobooth.",
    "Go for it.",
    "Nobody knew about the concept.",
    "We got 350 photos and videos.",
    "Works on all phones.",
    "We have gems in the gallery.",
    "Easy as pie.",
    "Why didn't we know about this before.",
    "My doubts vanished quickly, great.",
    "The guests got into it.",
    "Zero issues on the big day.",
    "Simple and effective.",
    "Our best wedding photo came from the QR code.",
    "The photos are stunning.",
    "Unbeatable value.",
    "Several guests asked us where we found it.",
    "We love scrolling through the gallery.",
    "Far exceeded our expectations.",
    "My only regret is not knowing about it sooner.",
    "The QR code blended right into the decor.",
    "So simple my grandparents managed.",
    "We already know we'll reuse it.",
    "The best surprise of our wedding.",
    "The guests contributed without even being asked.",
    "Everyone scanned it.",
    "More memories than with our photographer alone.",
    "We recommended it to all our friends.",
    "The most useful thing after the wedding.",
    "Nothing to fault.",
    "Every photo tells a moment.",
    "Glad we didn't hesitate.",
    "Support responsive even on Sundays.",
    "No more chasing after photos.",
    "Top responsiveness.",
    "No need to explain it to them.",
    "I recommend to everyone.",
    "Unexpected and gorgeous photos.",
    "Very happy.",
    "All good.",
    "Deserved from start to finish.",
    "280 photos and 45 videos, great.",
    "350 photos and 90 videos without doing anything.",
    "Perfect for the wedding.",
    "Responsive team.",
    "Exactly what we wanted.",
    "Gets the job done.",
    "Plus the posters are beautiful.",
    "Quick response to my questions.",
    "Guests understood in 5 seconds.",
    "Ordered in the evening, received in the morning.",
    "Good product.",
    "300 photos and 60 videos for 80 guests.",
    "No technical issues.",
    "The posters blend into the decor.",
    "380 photos and 100 videos. Thank you.",
    "No bad surprises.",
    "Perfect for a birthday.",
    "Everything was smooth.",
    "Five stars well deserved.",
    "Instant delivery, I love it.",
    "Quick and efficient.",
    "What an idea!",
    "Great for family reunions too.",
    "The posters are classy.",
    "A real gem.",
    "Tested and approved.",
    "Very satisfied with the service.",
    "The best for collecting memories.",
    "Nice surprise for the bride and groom.",
    "It made all the difference at our event.",
    "Very easy to set up.",
    "The QR code was scanned by everyone.",
    "Better than any other solution.",
    "We had a blast going through the gallery.",
    "Quality photos, nothing compressed.",
    "Support was very helpful.",
    "Highly recommend for any event.",
    "Memorable.",
    "The gallery is now our family treasure.",
    "Wouldn't change a thing.",
    "Every guest participated.",
    "Best investment for our event.",
    "Photos we'll keep forever.",
    "Pure happiness in a gallery.",
    "The whole family loved it.",
    "Simple, beautiful, effective."
  ];

  /* ── Fonction pour traduire les cartes d'avis visibles ── */
  var translated = new WeakSet();

  function translateReviewCards() {
    var cards = document.querySelectorAll('.rv-text');
    cards.forEach(function (card, i) {
      if (translated.has(card)) return;
      var idx = i % AVIS_EN.length;
      card.textContent = AVIS_EN[idx];
      translated.add(card);
    });
  }

  // Traduire les cartes initiales
  translateReviewCards();

  // Observer les nouvelles cartes chargées dynamiquement (bouton "Charger plus")
  var reviewGrid = document.querySelector('.rv-grid, [class*="rv-grid"], [id*="reviewsGrid"]');
  if (!reviewGrid) {
    reviewGrid = document.querySelector('main') || document.body;
  }

  var observer = new MutationObserver(function () {
    translateReviewCards();
  });
  observer.observe(reviewGrid, { childList: true, subtree: true });

  /* ── CARROUSEL "They talk about us" (carousel-card-text) ── */
  var CAROUSEL_EN = [
    '"95% of our guests scanned without us saying a thing. 155 photos and videos in 3 hours."',
    '"Honestly the best wedding purchase. We still look at the gallery every Sunday."',
    '"The QR code on the tables, a real surprise for everyone. 180 photos and 65 videos!"',
    '"4 generations together, everyone participated. Even my uncle who hates phones."',
    '"Baby shower, the whole family added their wishes on video. Our son will watch them in 18 years."',
    '"My friend\'s 30th birthday, we got 170 photos and 67 videos. She cried seeing all of it."',
    '"The poster was a real decorative element."',
    '"Family Christmas, about 200 photos and videos shared. My 68-year-old grandmother scanned it all by herself!"'
  ];

  var carouselCards = document.querySelectorAll('.carousel-card-text');
  if (carouselCards.length > 0) {
    carouselCards.forEach(function (card, i) {
      var idx = i % CAROUSEL_EN.length;
      card.textContent = CAROUSEL_EN[idx];
    });
  }

  /* ══════════ BLOG : corriger les URLs ══════════ */
  var domain = 'https://www.keepmemoriz.com';

  function fixBlogUrl(url) {
    if (!url) return url;
    url = url.replace(/^\/en\/en/g, '/en');
    if (url.indexOf(domain) !== -1) url = url.replace(domain, '');
    if (url.indexOf('/en/') !== 0 && (url.indexOf('/blogs/') !== -1 || url.indexOf('/products/') !== -1 || url.indexOf('/pages/') !== -1)) url = '/en' + url;
    return url;
  }

  if (typeof ARTICLES !== 'undefined' && Array.isArray(ARTICLES)) {
    ARTICLES.forEach(function (a) { if (a.url) a.url = fixBlogUrl(a.url); });
    if (typeof renderGrid === 'function') renderGrid();
  }
  if (typeof FEATURED_ARTICLE !== 'undefined' && FEATURED_ARTICLE && FEATURED_ARTICLE.url) {
    FEATURED_ARTICLE.url = fixBlogUrl(FEATURED_ARTICLE.url);
  }

  // Fix liens déjà rendus
  document.querySelectorAll('a[href*="/blogs/"]').forEach(function (a) {
    a.setAttribute('href', fixBlogUrl(a.getAttribute('href')));
  });
  document.querySelectorAll('a[href*="keepmemoriz.com/blogs/"]').forEach(function (a) {
    a.setAttribute('href', fixBlogUrl(a.getAttribute('href')));
  });

// Fix product & page links in article content
    document.querySelectorAll('.rte a[href*="/products/"], .rte a[href*="/pages/"]').forEach(function (a) {
      a.setAttribute('href', fixBlogUrl(a.getAttribute('href')));
    });
    document.querySelectorAll('.rte a[href*="keepmemoriz.com/products/"], .rte a[href*="keepmemoriz.com/pages/"]').forEach(function (a) {
      a.setAttribute('href', fixBlogUrl(a.getAttribute('href')));
    });

})();